(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["predictive-search-inline"] && !Shopify.designMode) return;
  try {
    // Inline-Suche: Dropdown NUR nach echter Nutzer-Interaktion oeffnen (pointerdown/
  // keydown auf dem Input), NICHT bei programmatischem Auto-Fokus beim Seitenladen.
  // Das CSS gated die Vorschlaege auf [data-user-opened]:focus-within.
  (function () {
    function markOpen(target) {
      if (!target || !target.closest) return;
      var input = target.closest('.predictive-search-inline .search-input');
      if (!input) return;
      var comp = input.closest('.predictive-search-inline');
      if (comp) comp.setAttribute('data-user-opened', '');
    }
    document.addEventListener('pointerdown', function (e) { markOpen(e.target); });
    document.addEventListener('keydown', function (e) { markOpen(e.target); });
    document.addEventListener(
      'focusout',
      function (e) {
        var comp = e.target && e.target.closest && e.target.closest('.predictive-search-inline');
        if (!comp) return;
        requestAnimationFrame(function () {
          if (!comp.contains(document.activeElement)) comp.removeAttribute('data-user-opened');
        });
      },
      true
    );
    // Klick aufs X (Reset) schliesst das Dropdown sauber (kein offener "Rest" mit
    // Vorschlaegen): Horizon leert das Feld, wir entfernen den Oeffnen-Marker, sodass
    // das :has()/:focus-within-Gate zumacht. Fokus bleibt — Tippen oeffnet neu.
    document.addEventListener('click', function (e) {
      var reset = e.target && e.target.closest ? e.target.closest('.predictive-search__reset-button') : null;
      if (!reset) return;
      var comp = reset.closest('.predictive-search-inline');
      if (!comp) return;
      comp.removeAttribute('data-user-opened');
      requestAnimationFrame(function () { comp.removeAttribute('data-user-opened'); });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["th-audio-player"] && !Shopify.designMode) return;
  try {
    class ThAudioPlayer extends HTMLElement {
    connectedCallback() {
      this.audio = this.querySelector('audio');
      this.btn = this.querySelector('[data-play]');
      this.wave = this.querySelector('[data-wave]');
      this.timeEl = this.querySelector('[data-time]');
      if (!this.audio) return;
      this.btn?.addEventListener('click', this.toggle);
      this.wave?.addEventListener('click', this.seek);
      this.audio.addEventListener('timeupdate', this.onTime);
      this.audio.addEventListener('play', this.onPlay);
      this.audio.addEventListener('pause', this.onPause);
      this.audio.addEventListener('ended', this.onEnd);
      this.audio.addEventListener('loadedmetadata', this.onTime);
    }

    disconnectedCallback() {
      this.audio?.pause();
    }

    fmt(s) {
      if (!isFinite(s)) return '0:00';
      const m = Math.floor(s / 60);
      const sec = Math.floor(s % 60);
      return m + ':' + (sec < 10 ? '0' : '') + sec;
    }

    /* QA-UX 12.10. (P3-9): play() liefert ein Promise, das bei schnellem Play/Pause
       mit AbortError rejected — abfangen, sonst unbehandelte Rejection in der Konsole. */
    safePlay() {
      const p = this.audio.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    }

    toggle = () => {
      if (!this.audio) return;
      if (this.audio.paused) this.safePlay();
      else this.audio.pause();
    };

    onTime = () => {
      if (!this.audio || !this.audio.duration) return;
      const p = this.audio.currentTime / this.audio.duration;
      this.style.setProperty('--progress', p.toFixed(4));
      if (this.timeEl) {
        const remain = this.audio.duration - this.audio.currentTime;
        this.timeEl.textContent = this.audio.currentTime > 0 ? this.fmt(remain) : this.fmt(this.audio.duration);
      }
    };

    onPlay = () => { this.setAttribute('playing', ''); this.btn?.setAttribute('aria-pressed', 'true'); };
    onPause = () => { this.removeAttribute('playing'); this.btn?.setAttribute('aria-pressed', 'false'); };
    onEnd = () => { this.removeAttribute('playing'); this.btn?.setAttribute('aria-pressed', 'false'); this.style.setProperty('--progress', 0); };

    seek = (event) => {
      if (!this.audio || !this.audio.duration || !this.wave) return;
      const rect = this.wave.getBoundingClientRect();
      const ratio = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
      this.audio.currentTime = ratio * this.audio.duration;
      if (this.audio.paused) this.safePlay();
    };
  }

  if (!customElements.get('th-audio-player')) {
    customElements.define('th-audio-player', ThAudioPlayer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["th-blog-quiz"] && !Shopify.designMode) return;
  try {
    (function () {
    function norm(s) {
      return String(s || '').toLowerCase().replace(/\s+/g, ' ').replace(/[.!?,;:"„“»«]/g, '').trim();
    }
    function push(ev) {
      try { (window.dataLayer = window.dataLayer || []).push(ev); } catch (e) {}
    }

    function initQuiz(root) {
      var dataEl = root.querySelector('[data-thbq-data]');
      if (!dataEl) return;
      var questions;
      try { questions = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!questions || !questions.length) return;

      var staticList = root.querySelector('[data-thbq-static]');
      var stage = root.querySelector('[data-thbq-stage]');
      var result = root.querySelector('[data-thbq-result]');
      var progress = root.querySelector('[data-thbq-progress]');
      var progressLabel = root.querySelector('[data-thbq-progress-label]');
      var progressBar = root.querySelector('[data-thbq-progress-bar]');
      var progressFill = root.querySelector('[data-thbq-progress-fill]');
      var scoreEl = root.querySelector('[data-thbq-score]');
      var msgEl = root.querySelector('[data-thbq-msg]');
      var areasEl = root.querySelector('[data-thbq-areas]');
      var live = root.querySelector('[data-thbq-live]');
      var againBtn = root.querySelector('[data-thbq-again]');
      var showAllBtn = root.querySelector('[data-thbq-show-all]');
      var formId = root.getAttribute('data-form-id') || (root.id || '').replace('thbq-', '').toUpperCase();
      var order = [];
      var idx = 0;
      var score = 0;
      var perArea = {};
      var started = false;
      var letters = 'ABCDEFGH';

      function el(tag, cls, text) {
        var e = document.createElement(tag);
        if (cls) e.className = cls;
        if (text) e.textContent = text;
        return e;
      }

      function updateProgress() {
        progressLabel.textContent = 'Frage ' + (idx + 1) + ' von ' + order.length;
        progressFill.style.width = Math.round((idx / order.length) * 100) + '%';
        progressBar.setAttribute('aria-valuenow', String(idx));
      }

      function showResult() {
        stage.hidden = true;
        progress.hidden = true;
        result.hidden = false;
        scoreEl.textContent = String(score);
        var pct = score / order.length;
        msgEl.textContent = pct >= 0.8
          ? 'Stark! Du bist auf einem sehr guten Weg.'
          : pct >= 0.5
            ? 'Solide Basis! Mit gezieltem Training holst du den Rest.'
            : 'Da geht noch was! Genau dafür gibt es den Testtrainer.';
        // Auswertung nach Bereichen (nur wenn es mehr als einen gibt)
        var keys = Object.keys(perArea);
        areasEl.textContent = '';
        if (keys.length > 1) {
          keys.sort(function (a, b) { return perArea[a].ok / perArea[a].n - perArea[b].ok / perArea[b].n; });
          keys.forEach(function (k) {
            var li = el('li', 'thbq__area-row');
            li.appendChild(el('span', 'thbq__area-name', k));
            li.appendChild(el('span', 'thbq__area-score', perArea[k].ok + ' von ' + perArea[k].n));
            if (perArea[k].ok < perArea[k].n) li.setAttribute('data-weak', '');
            areasEl.appendChild(li);
          });
          areasEl.hidden = false;
        } else {
          areasEl.hidden = true;
        }
        push({ event: 'th_quiz_complete', quiz_id: formId, quiz_score: score, quiz_total: order.length });
        result.focus({ preventScroll: true });
        result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      // Ablauf + Optik wie der TestRunner der Lernplattform: Option(en)
      // wählen (Radio/Checkbox + A/B/C/D-Buchstabe, Auswahl navy), dann
      // „Antwort prüfen“, dann Feedback grün/rot + Weiter.
      function renderQuestion() {
        updateProgress();
        stage.textContent = '';
        var item = questions[order[idx]];
        var free = item.kind === 'free';
        var multiple = !free && item.correct.length > 1;
        var qId = root.id + '-q';
        if (item.t) stage.appendChild(el('p', 'thbq__area', item.t));
        var qEl = el('p', 'thbq__q-text');
        qEl.id = qId;
        qEl.tabIndex = -1;
        String(item.q).split('\n').forEach(function (line, i) {
          if (i) qEl.appendChild(document.createElement('br'));
          qEl.appendChild(document.createTextNode(line));
        });
        stage.appendChild(qEl);
        if (item.img) {
          var img = el('img', 'thbq__img');
          img.src = item.img;
          img.alt = 'Abbildung zur Aufgabe';
          img.decoding = 'async';
          stage.appendChild(img);
        }
        if (multiple) stage.appendChild(el('p', 'thbq__sub', 'Mehrere Antworten sind richtig.'));
        var group = el('div', 'thbq__opts');
        group.setAttribute('role', 'group');
        group.setAttribute('aria-labelledby', qId);
        stage.appendChild(group);
        var answered = false;
        var chosen = [];
        var buttons = [];
        var input = null;

        if (free) {
          var lab = el('label', 'thbq__free-label', 'Deine Antwort');
          var inId = root.id + '-free';
          lab.setAttribute('for', inId);
          input = el('input', 'thbq__lead-input thbq__free-input');
          input.id = inId;
          input.type = 'text';
          input.autocomplete = 'off';
          input.setAttribute('autocapitalize', 'off');
          input.addEventListener('input', function () { checkBtn.disabled = !input.value.trim(); });
          input.addEventListener('keydown', function (ev) {
            if (ev.key === 'Enter' && input.value.trim() && !answered) { ev.preventDefault(); resolveFree(); }
          });
          group.appendChild(lab);
          group.appendChild(input);
        } else {
          buttons = item.options.map(function (opt, i) {
            var b = el('button', 'thbq__opt');
            b.type = 'button';
            b.setAttribute('aria-pressed', 'false');
            b.appendChild(el('span', multiple ? 'thbq__opt-dot thbq__opt-dot--box' : 'thbq__opt-dot'));
            b.appendChild(el('span', 'thbq__opt-letter', letters.charAt(i)));
            b.appendChild(el('span', 'thbq__opt-text', opt));
            b.addEventListener('click', function () {
              if (answered) return;
              if (multiple) {
                var p = chosen.indexOf(i);
                if (p >= 0) { chosen.splice(p, 1); b.removeAttribute('data-state'); b.setAttribute('aria-pressed', 'false'); }
                else { chosen.push(i); b.setAttribute('data-state', 'chosen'); b.setAttribute('aria-pressed', 'true'); }
              } else {
                chosen = [i];
                buttons.forEach(function (ob) { ob.removeAttribute('data-state'); ob.setAttribute('aria-pressed', 'false'); });
                b.setAttribute('data-state', 'chosen');
                b.setAttribute('aria-pressed', 'true');
              }
              checkBtn.disabled = chosen.length === 0;
            });
            group.appendChild(b);
            return b;
          });
        }

        function finish(ok, solutionText) {
          answered = true;
          if (ok) score++;
          var area = item.t || 'Allgemein';
          perArea[area] = perArea[area] || { ok: 0, n: 0 };
          perArea[area].n++;
          if (ok) perArea[area].ok++;
          checkBtn.remove();
          var fb = el('p', 'thbq__feedback', ok ? 'Richtig!' : 'Leider falsch. Richtig ist: ' + solutionText);
          fb.setAttribute('data-ok', ok ? '1' : '0');
          stage.appendChild(fb);
          live.textContent = fb.textContent;
          if (item.tip) stage.appendChild(el('div', 'thbq__tip', item.tip));
          var last = idx === order.length - 1;
          var next = el('button', 'thbq__next', last ? 'Ergebnis anzeigen' : 'Weiter');
          next.type = 'button';
          next.addEventListener('click', function () {
            if (last) { showResult(); return; }
            idx++;
            renderQuestion();
            var q = stage.querySelector('.thbq__q-text');
            if (q) q.focus({ preventScroll: true });
          });
          stage.appendChild(next);
          next.focus({ preventScroll: true });
        }

        function resolveChoice(picked) {
          buttons.forEach(function (b) { b.disabled = true; });
          var ok = picked.length === item.correct.length && picked.every(function (i) { return item.correct.indexOf(i) >= 0; });
          item.correct.forEach(function (i) { buttons[i].setAttribute('data-state', 'correct'); });
          picked.forEach(function (i) {
            if (item.correct.indexOf(i) < 0) buttons[i].setAttribute('data-state', 'wrong');
          });
          finish(ok, item.correct.map(function (i) { return letters.charAt(i) + ') ' + item.options[i]; }).join(', '));
        }

        function resolveFree() {
          input.disabled = true;
          var ok = norm(input.value) === norm(item.options[0]);
          input.setAttribute('data-state', ok ? 'correct' : 'wrong');
          finish(ok, item.options[0]);
        }

        var checkBtn = el('button', 'thbq__check', 'Antwort prüfen');
        checkBtn.type = 'button';
        checkBtn.disabled = true;
        checkBtn.addEventListener('click', function () {
          if (answered) return;
          if (free) { if (input.value.trim()) resolveFree(); return; }
          if (chosen.length) resolveChoice(chosen.slice());
        });
        stage.appendChild(checkBtn);
      }

      function start(shuffle) {
        order = questions.map(function (_, i) { return i; });
        if (shuffle) {
          for (var i = order.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var t = order[i]; order[i] = order[j]; order[j] = t;
          }
        }
        staticList.hidden = true;
        stage.hidden = false;
        result.hidden = true;
        progress.hidden = false;
        if (showAllBtn) showAllBtn.setAttribute('aria-expanded', 'false');
        idx = 0;
        score = 0;
        perArea = {};
        renderQuestion();
        if (!started) { started = true; push({ event: 'th_quiz_view', quiz_id: formId }); }
      }

      if (againBtn) againBtn.addEventListener('click', function () {
        start(true);
        var q = stage.querySelector('.thbq__q-text');
        if (q) q.focus({ preventScroll: true });
      });
      if (showAllBtn) showAllBtn.addEventListener('click', function () {
        var open = staticList.hidden;
        staticList.hidden = !open;
        showAllBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        showAllBtn.textContent = open ? 'Lösungen ausblenden' : 'Alle Fragen mit Lösungen';
      });

      // Lead-Formular: Ergebnis + Fragensammlungs-PDF per Mail anfordern (nur mit Einwilligung).
      var leadForm = root.querySelector('[data-thbq-lead-form]');
      var leadStatus = root.querySelector('[data-thbq-lead-status]');
      if (leadForm) {
        leadForm.addEventListener('submit', function (ev) {
          ev.preventDefault();
          var input = leadForm.querySelector('input[type="email"]');
          var consent = leadForm.querySelector('input[name="consent"]');
          var btn = leadForm.querySelector('button');
          var email = (input.value || '').trim();
          leadStatus.hidden = false;
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
            leadStatus.setAttribute('data-kind', 'err');
            leadStatus.textContent = 'Bitte gib eine gültige E-Mail-Adresse ein.';
            input.setAttribute('aria-invalid', 'true');
            input.focus();
            return;
          }
          input.removeAttribute('aria-invalid');
          if (consent && !consent.checked) {
            leadStatus.setAttribute('data-kind', 'err');
            leadStatus.textContent = 'Bitte bestätige, dass wir dir die Fragensammlung per E-Mail schicken dürfen.';
            consent.focus();
            return;
          }
          btn.disabled = true;
          leadStatus.removeAttribute('data-kind');
          leadStatus.textContent = 'Einen Moment, dein PDF wird erstellt ...';
          fetch('https://app.testhelden.com/api/mobile/quiz-lead', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              email: email,
              formId: formId,
              score: score,
              total: order.length || questions.length,
              sourceUrl: location.href.split('?')[0],
              examDate: (leadForm.querySelector('input[name="examDate"]') || {}).value || undefined
            })
          }).then(function (res) {
            if (!res.ok) throw new Error('http-' + res.status);
            leadStatus.setAttribute('data-kind', 'ok');
            leadStatus.textContent = 'Geschafft! Deine Fragensammlung ist unterwegs in dein Postfach.';
            leadForm.hidden = true;
            push({ event: 'th_quiz_lead', quiz_id: formId });
          }).catch(function () {
            btn.disabled = false;
            leadStatus.setAttribute('data-kind', 'err');
            leadStatus.textContent = 'Das hat leider nicht geklappt. Bitte versuche es gleich noch einmal.';
          });
        });
      }

      start(false);
    }

    function boot() {
      document.querySelectorAll('[data-thbq]').forEach(initQuiz);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["th-feed-item"] && !Shopify.designMode) return;
  try {
    /* th-feed — client-side relative time (German). Shared by the global Live-Feed
   section and the product „Live im Kurs" widget; runs once, updates every 60s
   so the feed keeps feeling live even on a CDN-cached page.
   Wording ladder (kept in sync with the Liquid fallback in snippets/th-rel-time):
   gerade eben → vor N Min → vor N Std (bis 6 Std) → heute früh/heute → gestern
   → Kurzdatum („3. Juli") — bei ruhigen Kursen wirkt „vor 14 Std" leerer als es ist. */
(function () {
  if (window.__thFeedRelTime) return;
  window.__thFeedRelTime = true;

  var MONTHS = [
    'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
    'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
  ];

  function startOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
  }

  function rel(iso) {
    var then = Date.parse(iso);
    if (isNaN(then)) return null;
    var diff = Math.floor((Date.now() - then) / 1000);
    if (diff < 0) diff = 0;
    if (diff < 60) return 'gerade eben';
    if (diff < 3600) {
      var m = Math.floor(diff / 60);
      return 'vor ' + m + ' Min';
    }
    if (diff < 21600) {
      var h = Math.floor(diff / 3600);
      return 'vor ' + h + ' Std';
    }
    var thenDate = new Date(then);
    var dayDiff = Math.round((startOfDay(new Date()) - startOfDay(thenDate)) / 86400000);
    if (dayDiff <= 0) return thenDate.getHours() < 12 ? 'heute früh' : 'heute';
    if (dayDiff === 1) return 'gestern';
    return thenDate.getDate() + '. ' + MONTHS[thenDate.getMonth()];
  }

  function tick() {
    var nodes = document.querySelectorAll('[data-th-feed-at]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var txt = rel(el.getAttribute('data-th-feed-at'));
      if (txt && el.textContent !== txt) el.textContent = txt;
    }
  }

  function boot() {
    tick();
    setInterval(tick, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
